import { Grid, Box } from '@chakra-ui/react'
import { FC, useMemo, useEffect } from 'react'

import useConciliationBudget from '@hook/budget/user-conciliation'
import useFilters from '@hook/shared/use-filters'
import useLayout from '@hook/shared/use-layout'
import useSessions from '@hook/shared/use-sessions'

import Layout from '@component/Layout'
import LayoutEmpty from '@component/Layout/Empty'
import LayoutFilters from '@component/Layout/Filters'
import LayoutLoader from '@component/Layout/Loader'
import TableGrid from '@component/Layout/TableGrid'
import GridQuantity from '@component/Layout/TableGrid/GridQuantity'
import LayoutTools from '@component/Layout/Tools'
import SelectedTableBar from '@component/Modules/Budget/SelectedTableBar'

import { disableActionsByDefault } from '@helper/budget/conciliation/disableActionsByDefault'
const ConciliationBudget: FC = () => {
  const { getFilters } = useFilters()
  const { menuToggle } = useLayout()
  const {
    loading,
    headers,
    actions,
    tableInteraction,
    data,
    handleLocalParams,
    filename,
    dataUpdate,
    saveUpdate,
    query,
    params,
    pagination,
    dataFooter,
    filters,
    setFilters,
    setQuery,
    getData,
    filtersList,
    clearAllFilters,
    handleUpdateParams
  } = useConciliationBudget()

  const { hasSessions } = useSessions()

  const height = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 30px)'
          : '100vh'
        : hasSessions
        ? 'calc(100vh - 160px)'
        : 'calc(100vh - 142px)',
    [menuToggle, hasSessions]
  )

  const tableHeight = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 237px)'
          : 'calc(100vh - 205px)'
        : hasSessions
        ? 'calc(100vh - 378px)'
        : 'calc(100vh - 346px)',
    [menuToggle, hasSessions]
  )

  useEffect(() => {
    handleLocalParams()
    data?.length === 0 && getData()

    getFilters({
      companies: true,
      compactCategories: true,
      centers: true,
      categories: true,
      categoryManagers: true,
      productManagers: true,
      yearBudget: true,
      monthBudget: true,
      historicBudget: true,
      operationBudget: true
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout title="Orçamento Conciliação">
      <Grid
        w="100vw"
        bg="white"
        h={height}
        templateColumns={!filters ? '100vw' : '260px calc(100vw - 260px)'}
      >
        {filters && (
          <LayoutFilters
            filters={filtersList}
            values={params}
            onChange={handleUpdateParams}
            loading={loading}
            canCancel={loading}
            onFilter={getData}
            onClearAllFilters={clearAllFilters}
          />
        )}
        <Box>
          <LayoutTools
            title={filename}
            filters={filters}
            actions={actions}
            onSearchChange={setQuery}
            toggleFilters={setFilters.toggle}
            isDisabled={loading || data.length === 0}
            disableActionsByDefault={disableActionsByDefault}
          />
          {loading ? (
            <LayoutLoader
              title="Recuperando informações..."
              message="Aguarde enquanto buscamos os registros no banco de dados"
            />
          ) : data.length === 0 ? (
            <LayoutEmpty
              title="Nada encontrado!"
              message="Filtre sua busca ao lado para obter informações"
            />
          ) : (
            <>
              <GridQuantity
                data={data}
                textButton="Salvar"
                disabled={dataUpdate.length === 0}
                onClick={saveUpdate}
              />

              <SelectedTableBar />

              <TableGrid
                id="purchase-budget-conciliation"
                entity="budget-conciliation"
                pagination={pagination}
                headers={headers}
                data={data}
                query={query}
                height={tableHeight}
                itsSortable={true}
                actions={tableInteraction}
                isFooter={true}
                dataFooter={dataFooter}
                isActionFooter={true}
                isPaged
              />
            </>
          )}
        </Box>
      </Grid>
    </Layout>
  )
}

export default ConciliationBudget
